<template>
  <div class="stats">
    <connection-counter :value="stats.contactsTotal | formatNumber('0,0')" :expandable="canExpand" @expand="() => expanded = !expanded" />
    <div v-if="expanded">
      <div class="section">
        <generic-counter :value="stats.usersEmployees | formatNumber('0,0')" label="users" class="top first" color="#048f68" icon="user"/>
        <generic-counter :value="stats.referralsActioned | formatNumber('0,0')" label="referrals" class="top" color="#dd17b1" icon="link"/>
      </div>

      <div class="section">
        <generic-counter :value="stats.referralsRecruiterAccepted | formatNumber('0,0')" label="requests" class="top first" color="#ffba00" icon="desktop" />
        <generic-counter :value="stats.applicationsTotal | formatNumber('0,0')" label="applications" class="top" color="#e5343b" icon="file-alt"/>
      </div>

      <div class="section">
        <generic-counter :value="stats.applicationsInterviewTotal | formatNumber('0,0')" label="interviews" class="top first" color="#464bff" icon="users"/>
        <generic-counter :value="stats.applicationsHiredTotal | formatNumber('0,0')"  label="hires" class="top" color="#0083ff" icon="handshake"/>
      </div>

    </div>
  </div>
</template>

<script>
import ConnectionCounter from '@/components/dashboard/connection-counter';
import GenericCounter from '@/components/dashboard/generic-counter';

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    canExpand: {
      type: Boolean,
      default: false,
    },
    isExpanded: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ConnectionCounter,
    GenericCounter,
  },
  data: () => ({
    expanded: false,
    stats: {},
  }),
  created() {
    this.refreshValues();

    if (this.isExpanded) {
      this.expanded = this.isExpanded;
    }
  },
  methods: {
    refreshValues() {
      this.stats = this.value.reduce((list, { key, value }) => ({
        ...list,
        [key]: (list[key] || 0) + (value ? parseInt(value, 10) : 0),
      }), {});
    },
  },
  watch: {
    value() {
      this.refreshValues();
    },
  },
};
</script>
<style lang="scss">
.stats {
  .stats-block {
    padding-left: inherit;
    padding-right: inherit;
    padding-bottom:0px;
    padding-top: 0.5em;
    margin-bottom: 0px;
    padding-right: 15px;
    padding-left: 15px;

  }

  .connection-counter, .generic-counter {
    flex: 1;
  }
  .section {
    display: flex;
    flex-direction: row;
  }
  .first {
    border-right-width: 0px;
  }

  .generic-counter {
    border-radius: 0px;
  }

  .top {
    border-top: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/stats.vue